var BaseUrl;
switch (process.env.NODE_ENV) {
  case 'development':
    BaseUrl = {
      // dev: 'https://thfapp.thehazelnutfactory.com',
      dev: 'http://192.168.1.15:8000',
    };
    break;
  case 'production':
    BaseUrl = {
      dev: 'https://thfapp.thehazelnutfactory.com',
    };
    break;
  default:
    BaseUrl = {
      dev: 'https://thfapp.thehazelnutfactory.com',
    };
    break;
}

export const imageUploadUrl = 'https://thfweb.thehazelnutfactory.com/api/upload-doc/';

export default BaseUrl;
